import type { Modals } from '../../../model/modals/types.tsx';

export const OPEN_MODAL = 'state.actions.modals.OPEN_MODAL' as const;

export type OpenModalAction = {
	type: typeof OPEN_MODAL;
	payload: Modals;
};

export const openModal = (payload: Modals): OpenModalAction => ({
	type: OPEN_MODAL,
	payload,
});

export const CLOSE_MODAL = 'state.actions.modals.CLOSE_MODAL' as const;

export type CloseModalAction = {
	type: typeof CLOSE_MODAL;
};

export const closeModal = (): CloseModalAction => ({
	type: CLOSE_MODAL,
});

export type Action = OpenModalAction | CloseModalAction;
